import { all } from 'redux-saga/effects'
import { watchFetchFarmers } from './AppSagas'

export default function* rootSaga() {
    yield all( [
        watchFetchFarmers()
    ] )
}